import StateContext from './StateContext';
import { Employee } from '../utils/AccountsAPI';

export const EmployeeInfoContext = StateContext<Employee | undefined>([{}, () => { }]);

export default EmployeeInfoContext;
